var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_9538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18414 18.4797H1.35156V1.82666H18.4748V5.04572V18.4797H11.7219",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6935 11.5638H11.3231V13.9382H8.50637V11.5638H6.12793V8.74311H8.50637V6.36865H11.3231V8.74311H13.6935V11.5638Z",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.101 18.48H18.4756",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6299 18.48H33.8449V13.0817C33.8449 12.4642 33.5939 11.9064 33.1876 11.4961C32.7772 11.0937 32.2195 10.8387 31.6019 10.8387C30.59 10.8387 29.7095 10.1654 29.4386 9.18933L28.7574 6.69136C28.4865 5.71927 27.606 5.04199 26.5941 5.04199H18.4707",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95776 24.7349C11.0238 24.7349 12.6987 23.06 12.6987 20.9939C12.6987 18.9278 11.0238 17.2529 8.95776 17.2529C6.89168 17.2529 5.2168 18.9278 5.2168 20.9939C5.2168 23.06 6.89168 24.7349 8.95776 24.7349Z",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7186 20.9938C10.7186 21.9659 9.92979 22.7548 8.9577 22.7548C7.98561 22.7548 7.19678 21.9659 7.19678 20.9938C7.19678 20.0217 7.98561 19.2329 8.9577 19.2329C9.92979 19.2329 10.7186 20.0217 10.7186 20.9938Z",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.864 24.7349C27.9301 24.7349 29.605 23.06 29.605 20.9939C29.605 18.9278 27.9301 17.2529 25.864 17.2529C23.7979 17.2529 22.123 18.9278 22.123 20.9939C22.123 23.06 23.7979 24.7349 25.864 24.7349Z",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6258 20.9938C27.6258 21.9659 26.837 22.7548 25.8649 22.7548C24.8928 22.7548 24.104 21.9659 24.104 20.9938C24.104 20.0217 24.8928 19.2329 25.8649 19.2329C26.837 19.2329 27.6258 20.0217 27.6258 20.9938Z",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8454 18.48H34.3952C34.7378 18.48 35.0565 18.6194 35.2836 18.8465C35.5107 19.0736 35.6502 19.3923 35.6502 19.7349C35.6502 20.4282 35.0884 20.9899 34.3952 20.9899H29.6064",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1244 20.9902H12.6982",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35156 18.48C1.35156 19.8704 2.47903 20.9899 3.86148 20.9899H5.20806",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2314 5.04594V3.13363C21.2314 2.09779 22.0641 1.26514 23.0999 1.26514C23.6139 1.26514 24.088 1.4723 24.4226 1.81094C24.7613 2.14958 24.9684 2.61969 24.9684 3.13363V5.04594",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2314 5.0459L21.602 8.20122C21.7334 9.31673 22.6776 10.1534 23.7971 10.1534H29.9883",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8458 13.938H18.4756",
    stroke: "#0D4248",
    strokeWidth: 0.770162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_9538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.095,
    height: 24.2665,
    fill: "white",
    transform: "translate(0.952637 0.866699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon2);
export default __webpack_public_path__ + "static/media/benefit-icon2.b2f330ae588b633ef6b1a35ab37d5c87.svg";
export { ForwardRef as ReactComponent };